module.exports = __webpack_public_path__ + "static/Yang.affd1b83.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Yang.jpg
// module id = 1330
// module chunks = 137408898365125